import { Result, RoleTransactionLimit } from "../models/interfaces";
import { BaseService } from "./BaseService";

export type Role = {
  id?: number;
  name?: string;
  description?: string;
  permissions?: string[];
  transactionTypes?: string[];
  transactionLimit?: number;
  menus?: string[];
};

export class RoleService extends BaseService {
  async assignRoles(
    userId: number | undefined,
    selectedRoles: number[]
  ): Promise<Result<boolean>> {
    return this.post(`users/${userId}/roles`, selectedRoles);
  }

  async setRoleTransactionLimit(
    roleId: number,
    params: {
      transactionType?: string | undefined;
      period?: number | undefined;
      amount?: number | undefined;
    }
  ): Promise<Result<RoleTransactionLimit>> {
    return this.post(`roles/${roleId}/transaction-limit`, {
      amount: params.amount,
      transactionTypeCode: params.transactionType,
      transactionLimitPeriod: params.period,
    });
  }

  async getRoleTransactionLimits(
    roleId: number
  ): Promise<Result<RoleTransactionLimit[]>> {
    return this.get(`roles/${roleId}/transaction-limit`);
  }

  async deleteRoleLimit(params: {
    roleId: number;
    transactionType: string;
    period: number;
  }): Promise<Result<boolean>> {
    return this.delete(`roles/${params.roleId}/transaction-limit`, {
      transactionTypeCode: params.transactionType,
      transactionLimitPeriod: params.period,
    });
  }

  async getRoles(params: { name?: string }): Promise<Result<Role[]>> {
    return this.get(`roles`, params);
  }

  async getRole(id: number): Promise<Result<Role>> {
    return this.get(`roles/${id}`);
  }

  async deleteRole(id: number): Promise<Result<boolean>> {
    return this.delete(`roles/${id}`);
  }

  async saveRole(
    params: {
      name: string;
      permissions?: string[];
      transactionTypes?: string[];
      transactionLimit?: number;
    },
    roleId?: number
  ): Promise<Result<Role | boolean>> {
    if (roleId) {
      return this.put(`roles/${roleId}`, {
        name: params.name,
        transactionLimit: params.transactionLimit,
      });
    } else {
      return this.post(`roles`, {
        name: params.name,
        transactionLimit: params.transactionLimit,
      });
    }
  }

  async getTransactionTypes(id: number): Promise<Result<Role[]>> {
    return this.get<Result<Role[]>>(`roles/${id}/transaction-types`);
  }

  async setTransactionTypes(
    params: {
      type: number;
      transactionTypes: string[];
    },
    roleId: number
  ): Promise<Result<boolean>> {
    return this.post<Result<boolean>>(
      `roles/${roleId}/transaction-types`,
      params
    );
  }

  async getPermissions(id: number): Promise<Result<string[]>> {
    return this.get(`roles/${id}/permissions`);
  }

  async setPermissions(
    roleId: number,
    permissions: string[]
  ): Promise<Result<boolean>> {
    return this.post(`roles/${roleId}/permissions`, permissions);
  }
}

export default new RoleService();
